import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/restaurant";

// ========  Restaurant Enroll  =====

export const RestEnrollAdd = async (values) => {
  return await axiosInstance(options).post(`${path}/rest-enroll/add`, values);
};

export const RestEnrollList = async (values) => {
  return await axiosInstance(options).post(`${path}/rest-enroll/enrollment-Details`, values);
};

//http://172.16.11.237:5500/webservice/api/v1/admin/restaurant/rest-enroll/edit
export const RestEnrollEdit = async (values) => {
  return await axiosInstance(options).put(`${path}/rest-enroll/edit`, values);
};

export const RestTransactionList = async (values) => {
  return await axiosInstance(options).post(`${path}/rest-enroll/transaction-details`, values);
};

//http://172.16.11.237:5500/webservice/api/v1/admin/restaurant/rest-enroll/renewenrollment
export const RestRenewEnroll = async (values) => {
  return await axiosInstance(options).put(`${path}/rest-enroll/renew-enrollment`, values);
};

//http://172.16.11.237:5500/webservice/api/v1/admin/restaurant/rest-enroll/delete
export const ResEnrollDelete = async (values) => {
  return await axiosInstance(options).delete(`${path}/rest-enroll/delete?o_id=${values[0]}`);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const getLineIntegrationSettings = async (id) => {
  return await axiosInstance(options).get(`${path}/line-integration?o_id=${id}`);
};

export const updateLineIntegrationSettings = async (values) => {
  return await axiosInstance(options).patch(`${path}/line-integration`, values);
};


export const ChatbotRestaurantList = async (params) => {
  return await axiosInstance(options).get(`${path}/chatbot/restaurants`, { params });
};

export const ChatbotRestaurantDetails = async (restaurantId) => {
  return await axiosInstance(options).get(`${path}/chatbot/restaurants/${restaurantId}`);
};

export const UpdateChatbotAccess = async (restaurantId, access_enabled) => {
  return await axiosInstance(options).patch(
    `${path}/chatbot/restaurants/${restaurantId}/access`,
    { access_enabled }
  );
};

const chatbotReferencePath = (restaurantId) => restaurantId
  ? `${path}/chatbot/restaurants/${restaurantId}/references`
  : `${path}/chatbot/references`;

export const ChatbotReferences = async (restaurantId) => (
  axiosInstance(options).get(chatbotReferencePath(restaurantId))
);

export const UploadChatbotReference = async (restaurantId, file) => {
  const body = new FormData();
  body.append("image", file);
  return axiosInstance(options).post(chatbotReferencePath(restaurantId), body);
};

export const DeleteChatbotReference = async (restaurantId, referenceId) => (
  axiosInstance(options).delete(`${chatbotReferencePath(restaurantId)}/${referenceId}`)
);

export const UpdateChatbotReference = async (restaurantId, referenceId, values) => (
  axiosInstance(options).patch(`${chatbotReferencePath(restaurantId)}/${referenceId}`, values)
);

// -------------------------------
